export default __webpack_public_path__ + "static/media/pantry1-afterD-1920w.1bdf88e2.avif";